import React, { useState } from 'react';
import { documentTypeServices } from '../../../APIServices/documentTypeServices';
import { useToast } from '../../../hooks/useToast';

function DeleteDocumentType({ getDocumentTypeData, getDeletedDocumentTypeData, setModalOpen, documentTypeData }) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);

  const softDeleteRestoreDocumentType = async () => {
    setButtonLoader(true);
    try {
      const data = await documentTypeServices.softDeleteRestoreDocumentType({
        id: documentTypeData?._id,
        type: 'delete',
      });
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Document type deleted successfully.', 'ok');
        getDocumentTypeData();
        getDeletedDocumentTypeData();
        setModalOpen('');
      } else {
        toast(data?.customMessage || 'Unable to delete document type.', 'warn');
      }
    } catch (error) {
      toast('Unable to delete document type. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={() => setModalOpen('')}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Delete Document Type</div>
            <div className="xs muted">Delete document type details</div>
          </div>
          <button className="icon-btn" onClick={() => setModalOpen('')}>
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-foot">
          <button className="btn btn-ghost" onClick={() => setModalOpen('')}>Cancel</button>
          <button
            className="btn btn-danger d-flex align-items-center justify-content-center gap-2"
            onClick={softDeleteRestoreDocumentType}
            disabled={buttonLoader}
          >
            {buttonLoader ? (
              <>
                <div className="buttonLoader"></div>
                <span>Deleting...</span>
              </>
            ) : (
              <>
                <i className="ti ti-check"></i>
                <span>Yes, Delete It!</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteDocumentType;
